<template>
  <div v-if="message" class="alert alert-success">
    <div class="container">
      {{ message }}
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'

  export default {
    data() {
      return {
        message: null
      }
    },
    created() {
      const flashMessage = Cookies.get('cs_flash_message')

      if (flashMessage && flashMessage !== '') {
        Cookies.remove('cs_flash_message')
        this.message = flashMessage
      }
    }
  }
</script>
